import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import './App.css';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import Report from './scene/report';
import { showResultHistoryAction } from './actions/result-history';
import Loading from './components/loading';
import MedicalHistory from './scene/medical-history';
import Register from './scene/register';
import Login from './scene/login';
import ResetPassword from './scene/reset-password';
import Me from './scene/me';
import Appointment from './scene/appointment';
class App extends Component {
  render() {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history} action={null} location={null} onLocationChanged={null}>
          <Switch>
            <Route exact path='/register' render={() => (<Register />)} />
              <Route exact path='/login' render={() => (<Login />)} />
              <Route exact path='/me' render={() => (<Me />)} />
              <Route exact path='/resetpassword' render={() => (<ResetPassword />)} />
            <Route exact path='/medicalhistory' render={() => (<MedicalHistory />)} />
              <Route
                  exact
                  path='/appointment/:orgCode'
                  render={({ match }) => (<Appointment orgCode={match.params.orgCode} />)} />
            <Route
              exact
              path='/report/:id'
              render={({ match }) => (<Report id={match.params.id} />)} />
            <Route
              exact
              path='/history/:id'
              render={({ match }) => (<Loading
                title='个人健康管理报告'
                onEnter={() => store.dispatch(showResultHistoryAction({
                  id: match.params.id,
                  replaceHistory: true
                }))} />)
              } />
          </Switch>
        </ConnectedRouter>
      </Provider>
    );
  }
}

App.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default hot(module)(App);



// WEBPACK FOOTER //
// ./src/App.js